// EHCP
import { ReactComponent as SectionA } from '../stories/assets/navIcons/section-a.svg'
import { ReactComponent as SectionB } from '../stories/assets/navIcons/section-b.svg'
import { ReactComponent as SectionC } from '../stories/assets/navIcons/section-c.svg'
import { ReactComponent as SectionD } from '../stories/assets/navIcons/section-d.svg'
import { ReactComponent as SectionE } from '../stories/assets/navIcons/section-e.svg'
import { ReactComponent as SectionF } from '../stories/assets/navIcons/section-f.svg'
import { ReactComponent as SectionG } from '../stories/assets/navIcons/section-g.svg'
import { ReactComponent as SectionH1 } from '../stories/assets/navIcons/section-h1.svg'
import { ReactComponent as SectionH2 } from '../stories/assets/navIcons/section-h2.svg'
import { ReactComponent as SectionI } from '../stories/assets/navIcons/section-i.svg'
import { ReactComponent as SectionJ } from '../stories/assets/navIcons/section-j.svg'
import { ReactComponent as SectionK } from '../stories/assets/navIcons/section-k.svg'
import { ReactComponent as AdditionalCriteria } from '../stories/assets/navIcons/additional-criteria.svg'
import { ReactComponent as GoodPracticeChecklist } from '../stories/assets/navIcons/checklist.svg'
// AR
import { ReactComponent as Theme1 } from '../stories/assets/navIcons/statutory-requirements.svg'
import { ReactComponent as Theme2 } from '../stories/assets/navIcons/voice-cyp.svg'
import { ReactComponent as Theme3 } from '../stories/assets/navIcons/attainment-progress.svg'
import { ReactComponent as Theme4 } from '../stories/assets/navIcons/other-areas-need.svg'
import { ReactComponent as Theme5 } from '../stories/assets/navIcons/targets-transition-planning.svg'
import { ReactComponent as Theme6 } from '../stories/assets/navIcons/outcome-monitor.svg'
// import { ReactComponent as Provision } from "../stories/assets/navIcons/provision.svg";
import { ReactComponent as CurrentAssessment } from '../stories/assets/navIcons/current-assessment.svg'
import { ReactComponent as PersonCentred } from '../stories/assets/navIcons/person-centred.svg'
import { ReactComponent as EpAdvice } from '../stories/assets/navIcons/ep-advice.svg'
import { ReactComponent as ValueAdded } from '../stories/assets/navIcons/value-added.svg'
import { ReactComponent as AdditionalComponents } from '../stories/assets/navIcons/additional-components.svg'
import { ReactComponent as Summary } from '../stories/assets/navIcons/summary.svg'
import { ReactComponent as Icon } from '../stories/assets/user_profile.svg'
import { ReactComponent as UploadAuditsSVG } from '../stories/assets/navIcons/upload-audits.svg'
import { ReactComponent as UserManagementSVG } from '../stories/assets/navIcons/user-management.svg'
import { ReactComponent as AssignReviewsSVG } from '../stories/assets/navIcons/assign-reviews.svg'
import { ReactComponent as ReviewsSVG } from '../stories/assets/navIcons/view-reviews.svg'
import { ReactComponent as LiveReviewsSVG } from '../stories/assets/navIcons/live-reviews.svg'
import { ReactComponent as ModeratedReviewsSVG } from '../stories/assets/navIcons/moderated-reviews.svg'
import { ReactComponent as DashboardSVG } from '../stories/assets/navIcons/dashboard.svg'
import { ReactComponent as BenchmarkingSVG } from '../stories/assets/navIcons/benchmarking.svg'
import { ReactComponent as ExportSVG } from '../stories/assets/navIcons/export.svg'
import { ReactComponent as QueryBuilderSVG } from '../stories/assets/navIcons/query-builder.svg'
import { ReactComponent as FurtherDataSVG } from '../stories/assets/navIcons/further-data.svg'
import { ReactComponent as ThemeCommentsSVG } from '../stories/assets/navIcons/theme-comments.svg'
import { ReactComponent as OutcomesMonitorSVG } from '../stories/assets/navIcons/outcomes-monitor.svg'

const ICONS = {
  'timeliness-&-quality': <Theme1 />,
  'meeting-needs': <Theme2 />,
  outcomes: <Theme3 />,
  provision: <Theme4 />,
  'post-annual-review': <Theme5 />,
  'outcomes-monitoring': <Theme6 />,
  summary: <Summary />,
  'returned-within-6-weeks-of-request': <EpAdvice />,
  'background-&-timeliness': <Theme1 />,
  accessible: <Theme2 />,
  'current-assessment': <CurrentAssessment />,
  'person-centred': <PersonCentred />,
  'value-added': <ValueAdded />,
  'additional-components': <AdditionalComponents />,
  'user-management': <UserManagementSVG />,
  'upload-audits': <UploadAuditsSVG />,
  'assign-reviews': <AssignReviewsSVG />,
  reviews: <ReviewsSVG />,
  'live-reviews': <LiveReviewsSVG />,
  'moderated-reviews': <ModeratedReviewsSVG />,
  dashboard: <DashboardSVG />,
  benchmarking: <BenchmarkingSVG />,
  export: <ExportSVG />,
  'query-builder': <QueryBuilderSVG />,
  'further-data': <FurtherDataSVG />,
  'theme-comments': <ThemeCommentsSVG />,
  'explanatory-comments': <ValueAdded />,
  'outcomes-monitor': <OutcomesMonitorSVG />,
  'section-a': <SectionA />,
  'section-b': <SectionB />,
  'section-c': <SectionC />,
  'section-d': <SectionD />,
  'section-e': <SectionE />,
  'section-f': <SectionF />,
  'section-g': <SectionG />,
  'section-h1': <SectionH1 />,
  'section-h2': <SectionH2 />,
  'section-i': <SectionI />,
  'section-j': <SectionJ />,
  'section-k': <SectionK />,
  'additional-questions': <AdditionalCriteria />,
  'good-practice-checklist': <GoodPracticeChecklist />
}
export default function getSvg(id) {
  return ICONS[id] || <Icon />
}
